import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/common/routes/requireAuth'
import Step3 from '@/pages/organizations/join/step3'

export const Route = createFileRoute('/app/organizations/join/$orgtypeMachineName/$organizationId')({
  beforeLoad: ({ context }) => {
    requireAuth(context)
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { orgtypeMachineName, organizationId } = Route.useParams()
  return (
    <Step3
      orgTypeMachineName={orgtypeMachineName}
      organizationId={parseInt(organizationId, 10)}
    />
  )
}
